import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navigation from './components/Navigation';
import { setupAxiosInterceptors } from './utils/axiosInterceptor';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import Profile from './pages/Profile';
import AdminDashboard from './pages/AdminDashboard';
import FileManager from './pages/FileManager';
import BestDeals from './pages/BestDeals';
import Updates from './pages/Updates';
import OneStop from './pages/OneStop';
import OAuth2RedirectHandler from './pages/OAuth2RedirectHandler';
import SurveyList from './pages/SurveyList';
import SurveyTaker from './pages/SurveyTaker';
import SurveyResults from './pages/SurveyResults';
import SearchResults from './pages/SearchResults';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import AuthDebug from './components/AuthDebug';
import TestAdminPage from './pages/TestAdminPage';
import SEOHead from './components/SEOHead';
import GoogleAnalytics, { initGA } from './components/GoogleAnalytics';
import { HelmetProvider } from 'react-helmet-async';
import './styles/mobile-responsive.css';

function App() {
  // Initialize Google Analytics and Axios Interceptors
  React.useEffect(() => {
    initGA();
    setupAxiosInterceptors(); // Setup automatic token refresh
  }, []);

  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <SEOHead />
          <GoogleAnalytics />
          <Navigation />
          <main>
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/files" element={<FileManager />} />
            <Route path="/best-deals" element={<BestDeals />} />
            <Route path="/updates" element={<Updates />} />
            <Route path="/onestop" element={<OneStop />} />
            <Route path="/surveys" element={<SurveyList />} />
            <Route path="/surveys/:id/take" element={<SurveyTaker />} />
            <Route path="/surveys/:id/results" element={<SurveyResults />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              } 
            />
            <Route 
              path="/api/analytics" 
              element={
                <AdminRoute>
                  <AnalyticsDashboard />
                </AdminRoute>
              } 
            />
            <Route path="/auth-debug" element={<AuthDebug />} />
            <Route path="/test-admin" element={<TestAdminPage />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <div className="container mt-4">
                    <h2>Dashboard</h2>
                    <p>Welcome to your dashboard! This is a protected route.</p>
                    <p>Visit your <a href="/profile">profile</a> to manage your account.</p>
                  </div>
                </ProtectedRoute>
              } 
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;